import React from "react";
import { Stack, Text, ITextStyles, StackItem } from "@fluentui/react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import styles from "./Maintenance.module.css";

const headerStyles: ITextStyles = {
    root: {
        display: "flex",
        fontSize: 20,
        fontWeight: 600,
        marginBottom: 20,
    },
};

const contentStyles: ITextStyles = {
  root: {
    fontSize: 16,
    lineHeight: 1.5,
  },
};

const Maintenance: React.FC = () => {
  return (
    <Stack className={styles.mainLayout}>
      <StackItem>
        <Header />
      </StackItem>
      <StackItem className={styles.mainContent}>
        <div className={styles.versionContainer}>
          <Text styles={headerStyles}>Maintenance </Text>
          <Text styles={contentStyles}>
              The application is down for maintenance, please check back later.
          </Text>
        </div>
      </StackItem>
      <StackItem>
        <Footer />
      </StackItem>
    </Stack>
  );
};

export default Maintenance;
